<div #popup class=" mat-dialog-edition-form" appDraggable>
<div class="popup-header d-flex justify-content-between align-items-center position-relative">
  <strong class="title position-absolute top-50 start-50 translate-middle text-center fs-6">
    {{ isEdit || isControlPointDetailEdit ? ('POPUP.CONTROL_POINT_EDIT' | translate) : ('POPUP.NEW_MEASUREMENT_POINT' | translate) }}
  </strong>
  <button type="button" class="btn-close ms-auto p-2" data-bs-dismiss="modal" aria-label="Close"
    (click)="onClose()"></button>
</div>


  <!-- CONTENT -->
  <div class="popup-content">
    <form class="form" [formGroup]="form!" (ngSubmit)="onSubmit()" id="ngForm">
      <!-- fist 2 rows are used in 'create new control point' -->
      @if (!isEdit) {

      <!-- ROW 1 -->
      <div class="d-flex">
        <div class="row-item-width-25 input-container">
          <label class="input-label">{{ 'FORM.NUMBER' | translate }}<span
              class="text-danger"> * </span></label>
          <input class="input-field" id="number" placeholder="" formControlName="number" name="number" type="number" />
          @if(form?.get('number')?.invalid && form?.get('number')?.touched){
          <div class="input-errors">
            @if(form?.get('number')?.errors?.['pattern']){
            <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
            }
            @if(form?.get('number')?.errors?.['required']){
            <span>{{ 'ERRORS.NUMBER_REQUIRED' | translate }}</span>
            }
          </div>
          }
        </div>

        <div class="row-item-width-75 input-container">
          <label class="input-label">{{ 'FORM.NAME' | translate }}<span
              class="text-danger"> * </span></label>
          <input class="input-field" id="name" placeholder="{{ 'FORM.NAME' | translate }}" formControlName="name"
            name="name" type="text" />

          @if (form?.get('name')?.invalid && form?.get('name')?.touched) {
          <div class="input-errors">
            @if (form?.get('name')?.errors?.['required']) {
            <span>{{ 'ERRORS.NAME_REQUIRED' | translate }}</span>
            } @if (form?.get('name')?.errors?.['minlength']) {
            <span>{{ 'ERRORS.NAME_MIN_LENGTH' | translate }}</span>
            } @if (form?.get('name')?.errors?.['pattern']) {
            <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
            }
          </div>
          }
        </div>
      </div>

      <!-- ROW 2 -->
      <div class="d-flex mt-4">
        <div class="row-item-width-50 input-container">
          <label class="input-label">{{ 'FORM.DESCRIPTION' | translate }}</label>
          <input class="input-field" id="description" placeholder="{{ 'FORM.DESCRIPTION' | translate }}"
            formControlName="description" name="description" type="text" />
          @if(form?.get('description')?.invalid && form?.get('description')?.touched){
          <div class="input-errors">
            @if(form?.get('description')?.errors?.['pattern']){
            <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
            }
          </div>
          }
        </div>

        <div class="row-item-width-50 input-container">
          <label class="input-label">{{ 'FORM.DEVICE' | translate }}</label>

          <ng-select name="device" id="id" [items]="seismographList" bindLabel="serialNumber" formControlName="device"
            [addTag]="true" [hideSelected]="false" [multiple]="false" [closeOnSelect]="true"
            notFoundText="{{ 'PLACEHOLDERS.NO_ITEM_FOUND' | translate }}"
            placeholder="{{ 'PLACEHOLDERS.SELECT_DEVICE' | translate }}">
          </ng-select>

          @if (form?.get('device')?.invalid && form?.get('device')?.touched) {
          <div class="input-errors">
            @if (form?.get('device')?.errors?.['required']) {
            <span>{{ 'ERRORS.NAME_REQUIRED' | translate }}</span>
            } @if (form?.get('device')?.errors?.['minlength']) {
            <span>{{ 'ERRORS.NAME_MIN_LENGTH' | translate }}</span>
            } @if (form?.get('device')?.errors?.['pattern']) {
            <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
            }
          </div>
          }
        </div>
      </div>
      }

      <!-- ROW 3 -->
      <div class="d-flex mt-4">
        <div class="row-item-width-100 input-container">
          <label class="input-label">{{ 'FORM.EPSG' | translate }}<span
              class="text-danger"> * </span></label>
          <!-- <input class="input-field" id="number" formContro lName="number" name="number" type="text" /> -->
          <ng-select [items]="filteredEpsgCodes" [typeahead]="typeahead$" bindLabel="text" bindValue="id"
            placeholder="{{'PLACEHOLDERS.SEARCH_EPSG' | translate }}"
            typeToSearchText="{{ 'PLACEHOLDERS.TYPE_TO_SEARCH' | translate }}" [(ngModel)]="selectedEpsg"
            [ngModelOptions]="{ standalone: true }" [searchable]="true" [compareWith]="compareItems"
            [loading]="loading">
            <!-- Shows loading spinner when searching -->
          </ng-select>
          @if(epsgIsOk === false){
          <div class="input-errors">
            <span>{{ 'ERRORS.INVALID_EPSG' | translate }}</span>
          </div>
          }
        </div>
      </div>
        <div class="d-flex mt-4">
          <div class="row-item-width-100 input-container">
            <label class="input-label">{{ 'FORM.STANDARD_COMPLIANCE_LABEL' | translate }}</label>
            <ng-select 
              [items]="ponderations" 
              bindLabel="name" 
              bindValue="standardCode"
              [(ngModel)]="selectedStandardCode"
              [ngModelOptions]="{standalone: true}"
              
              [multiple]="false"
              [closeOnSelect]="true"
              [hideSelected]="false"
              [searchable]="false">
            </ng-select>
          </div>
        </div>

      <!-- ROW 4 -->
      <div class="d-flex justify-content-between mt-4">
        <div class="row-item-width-33  input-container d-flex">
          <label class="input-label">{{ C1 }}<span
              class="text-danger"> * </span></label>
          <input class="input-field" id="x" placeholder="x" formControlName="x" name="x" type="text" />
          @if(form?.get('x')?.invalid && form?.get('x')?.touched){
          <div class="input-errors">
            @if(form?.get('x')?.errors?.['pattern']){
            <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
            }
          </div>
          }
        </div>

        <div class="row-item-width-33  input-container">
          <label class="input-label">{{ C2 }}<span
              class="text-danger"> * </span></label>
          <input class="input-field" id="y" placeholder="y" formControlName="y" name="y" type="text" />
          @if(form?.get('y')?.invalid && form?.get('y')?.touched){
          <div class="input-errors">
            @if(form?.get('y')?.errors?.['pattern']){
            <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
            }
          </div>
          }
        </div>

        <div class="row-item-width-33  input-container">
          <label class="input-label">{{ C3 }}<span
              class="text-danger"> * </span></label>
          <input class="input-field" id="z" placeholder="z" formControlName="z" name="z" type="number" />
          @if(form?.get('z')?.invalid && form?.get('z')?.touched){
          <div class="input-errors">
            @if(form?.get('z')?.errors?.['pattern']){
            <span>{{ 'ERRORS.INVALID_CHARACTERS' | translate }}</span>
            }
          </div>
          }
        </div>
      </div>
    </form>
  </div>

  <!-- 
    FOOTER -->
  <div class="popup-footer">
    <button class="secondary-button popup-secondary-button" (click)="onClose()">{{ 'BUTTONS.CANCEL' | translate }}</button>
    <button class="primary-button popup-primary-button" form="ngForm" type="submit">{{ 'BUTTONS.CONFIRM' | translate }}</button>
  </div>
</div>